import React from "react";
import { Box } from "@mui/material";

const RotatingReel = () => {
  const IMAGE_URL = "/assets/rotating-reel.jpg";

  return (
    <Box
      sx={{
        width: "100%",
        height: "200px",
        overflow: "hidden",
        position: "relative",
        backgroundColor: "#000",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "5140px",
          animation: "reel-scroll 60s linear infinite",
          "@keyframes reel-scroll": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-2570px)" },
          },
        }}
      >
        <img
          src={IMAGE_URL}
          alt="Rotating Reel"
          width={2570}
          height={200}
          style={{ display: "block" }}
        />

        <img
          src={IMAGE_URL}
          alt="Rotating Reel"
          width={2570}
          height={200}
          style={{ display: "block" }}
        />
      </Box>
    </Box>
  );
};

export default RotatingReel;
